import React, { useState, useEffect } from "react";
import { Loader2, X } from "lucide-react";

import filetype from "../assets/images/filetypesvg.svg";
import downarrow from "../assets/images/arrow.png";
import closebtn from "../assets/images/closebtn.png";
import done from "../assets/images/done.png";
import { Alert } from "antd";

const apiHost = process.env.REACT_APP_FHOST;
const apiPort = process.env.REACT_APP_FPORT;

const UploadD = ({ io_type, c_type }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    if (c_type) {
      const lastWord = c_type;
      setConvertFormat(lastWord);
    }
  }, [c_type]);

  const [convertFormat, setConvertFormat] = useState( "none");
  const [compressSize, setCompressSize] = useState("none");
  const [selectedIndexes, setSelectedIndexes] = useState([]);
  const [processingStatus, setProcessingStatus] = useState({});
  const [showUploadView, setShowUploadView] = useState(true);
  const [isDragging, setIsDragging] = useState(false);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [visible, setVisible] = useState(false); // --alert button
  const [warMsg, setWarMsg] = useState([]); // Warning message store in this part
  const [infoMsg, setInfoMsg] = useState(false); // Information message visible
  const [infoCnt, setInfoCnt] = useState([]); // Information content in this part
  const [processedSizesMB, setProcessedSizesMB] = useState({});

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [visible]);
  useEffect(() => {
    if (infoMsg) {
      const timer = setTimeout(() => {
        setInfoMsg(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [infoMsg]);

  var warningMessages = {
    maxfiles: "Maximum 10 images only processed",
    supportedFiles: "Please select only PNG, JPG, or JPEG files",
    fileSize: "Uploaded image size must be maximum 5MB ",
  };

  // const DROPBOX_API_BASE = "https://api.dropboxapi.com/2/files/get_metadata";
  // const ACCESS_TOKEN = "f7usva58os6c7kv";

  // // Fetch file metadata from Dropbox
  // const getFileMetadata = async (filePath) => {
  //   try {
  //     const response = await axios.post(
  //       DROPBOX_API_BASE,
  //       { path: filePath }, // Provide the Dropbox file path
  //       {
  //         headers: {
  //           Authorization: `Bearer ${ACCESS_TOKEN}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //        console.log(response.data);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching file metadata:", error);
  //     return null;
  //   }
  // };

  // // Handle Dropbox files
  // const handleDropboxFiles = async (files) => {
  //   const updatedFiles = await Promise.all(
  //     files.map(async (file) => {
  //       // Ensure `file.path_lower` is passed as the file path
  //       const metadata = await getFileMetadata(file.path_lower);
  //       const mimeType =
  //         metadata?.["media_info"]?.["metadata"]?.["mime_type"] || "application/octet-stream";

  //       return {
  //         file: new File([file], file.name, { type: mimeType }),
  //         preview: file.thumbnailLink || URL.createObjectURL(new Blob([file])),
  //       };
  //     })
  //   );

  //   addNewFiles(updatedFiles);
  // };

  // const handleDropboxFiles = async (files) => {
  //     const updatedFiles = await Promise.all(
  //         files.map(async (file) => {
  //             try {
  //                 const response = await axios.head(file.link); // Perform a HEAD request to get file metadata
  //                 const mimeType = response.headers["content-type"]; // Extract the MIME type
  //                 return {
  //                     file: new File([file], file.name, { type: mimeType }),
  //                     preview: file.thumbnailLink || URL.createObjectURL(new Blob([file])),
  //                 };
  //             } catch (error) {
  //                 console.error("Error fetching file metadata:", error);
  //                 return {
  //                     file: new File([file], file.name, { type: file.type || "application/octet-stream" }),
  //                     preview: file.thumbnailLink || URL.createObjectURL(new Blob([file])),
  //                 };
  //             }
  //         })
  //     );

  //     addNewFiles(updatedFiles);
  // };

  // New function to handle files from Google Drive

  const handleDriveFiles = (files) => {
    const processedFiles = files.map((file) => ({
      file: new File([file], file.name, { type: "image/jpeg" }), // Adjust type as needed
      preview: file.url,
    }));

    addNewFiles(processedFiles);
  };

  // Common function to add new files
  const addNewFiles = (newFiles) => {
    setSelectedFiles((prev) => {
      const updatedFiles = [...prev, ...newFiles];

      if (updatedFiles.length > 10) {
        alert("Maximum 10 images allowed");

        return prev;
      }
      setSelectedIndexes((prevIndexes) => [
        ...prevIndexes,
        ...Array(newFiles.length).fill(true),
      ]);
      console.log("selected by hari ", selectedIndexes);
      setShowUploadView(false);
      return updatedFiles;
    });
  };

  // Pass these handlers to the components
  // const dropboxProps = {
  //     onSuccess: handleDropboxFiles,
  // };

  // const gdriveProps = {
  //     onSelect: handleDriveFiles,
  // };

  const [firstarrow, setFirstarrow] = useState("180deg");
  const [secondarrow, setSecondarrow] = useState("180deg");
  // convert to
  const [showDiv, setShowDiv] = useState(false);
  const [showDiv2, setShowDiv2] = useState(false);

  // Function to handle input hover or click
  const handleInputInteraction = () => {
    setShowDiv(true); // Show the div
    setFirstarrow("0deg");
  };
  const handleInputInteraction2 = () => {
    setShowDiv2(true);
    setSecondarrow("0deg");
  };

  // ==================


  // ============
  // Function to handle mouse leaving the div

  const formatChangeEvent = (event) => {
    console.log("is is working ");

    setShowDiv(false);
    setConvertFormat(event);
  };

  const compressSizeChangeEvent = (event) => {
    setShowDiv2(false);
    setCompressSize(event);
  };

  //
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);

    processNewFiles(files);
  };

  const processNewFiles = async (files) => {
    const validFiles = files.filter((file) => {
      const isValid = ["image/png", "image/jpeg", "image/jpg"].includes(
        file.type
      );
      return isValid;
    });

    const fileSize = files.filter((file) => {
      return file.size <= 1024 * 1024 * 5; // Max 5MB
    });

    if (fileSize.length !== files.length) {
      setWarMsg("Uploaded image size must be maximum 5MB");
      setVisible(true);
      return;
    }

    if (validFiles.length === 0) {
      setWarMsg("Please select only PNG, JPG, or JPEG files");
      setVisible(true);
      return;
    }

    if (validFiles.length + selectedFiles.length > 10) {
      setWarMsg("Maximum 10 images only processed");
      setVisible(true);
      return;
    }

    // 👇 Compress images and create previews using Canvas API
    const compressAndPreview = (file) => {
      return new Promise((resolve) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          img.src = e.target.result;
        };

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          const MAX_WIDTH = 1024;
          const scale = MAX_WIDTH / img.width;
          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scale;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert to base64 (JPEG, 0.7 quality)
          const compressedDataUrl = canvas.toDataURL("image/jpeg", 0.7);

          resolve({ file, preview: compressedDataUrl });
        };

        reader.readAsDataURL(file);
      });
    };

    const compressedFiles = await Promise.all(
      validFiles.map(compressAndPreview)
    );

    setSelectedFiles((prev) => [...prev, ...compressedFiles]);
    setSelectedIndexes((prev) => [
      ...prev,
      ...Array(validFiles.length).fill(true),
    ]);
    setShowUploadView(false);
  };

  const handleRemoveImage = (index) => {
    const removedFile = selectedFiles[index];
    console.log("index", index);

    // Avoid revoking before state update completes
    setSelectedFiles((prev) => {
      const updatedFiles = prev.filter((_, i) => i !== index);

      return updatedFiles;
    });

    console.log(selectedIndexes);
    setSelectedIndexes((prev) => {
      const updatedIndexes = prev.filter((_, i) => i !== index);
      return updatedIndexes;
    });

    let updatePS = processingStatus;
    console.log("processingStatus", updatePS);

    //updateing processing state
    function removeandShift(updatePS, index) {
      let values = Object.values(updatePS);
      values.splice(index, 1);

      let newObj = {};
      values.forEach((val, positions) => {
        newObj[positions] = val;
      });

      setProcessingStatus(newObj);
    }
    removeandShift(updatePS, index);

    // Revoke the blob URL after the state update
    setTimeout(() => {
      // Ensure the URL is revoked only if the file is removed
      if (removedFile && removedFile.preview) {
        URL.revokeObjectURL(removedFile.preview);
      }
    }, 3000);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(true);
    const files = Array.from(e.dataTransfer.files);
    processNewFiles(files);
  };

  // console.log("Updated selectedFiles:", selectedFiles);

  const toggleImageSelection = (index) => {
    setSelectedIndexes((prev) => {
      const newIndexes = [...prev];
      newIndexes[index] = !newIndexes[index];
      return newIndexes;
    });
  };

  const handleProcessImages = async () => {
    if (!selectedIndexes.some((index) => index)) {
      // alert('Please select at least one image');
      setInfoMsg(true);
      setInfoCnt((val) => (val = "Please select at least one image"));
      return;
    }

    if (convertFormat === "none" && compressSize === "none") {
      // alert('Please select either convert format or compress size');
      setInfoCnt(
        (val) => (val = "Please select either convert format or compress size")
      );
      setInfoMsg(true);
      return;
    }

    const formData = new FormData();

    // Add only selected files to formData

    selectedFiles.forEach((fileObj, index) => {
      if (selectedIndexes[index]) {
        // console.log(fileObj.file);
        formData.append("files", fileObj.file); // change this files --> images
      }
    });

    const actualType = selectedFiles.map((fileObject) => {
      // Extract the file's type and return only the extension
      const mimeType = fileObject.file.type; // e.g., 'image/png'
      return mimeType.split("/")[1]; // Returns 'png', 'jpeg', etc.
    });

    // console.log(actualType);

    formData.append(
      "targetFormat",
      convertFormat != "none" ? convertFormat : "none"
    );
    formData.append(
      "compressionPercentage",
      compressSize != "none" ? compressSize : "100"
    );

    try {
      // Update UI to show processing state
      const newStatus = {};
      selectedIndexes.forEach((isSelected, index) => {
        if (isSelected) {
          newStatus[index] = "processing";
        }
      });
      setProcessingStatus(newStatus);
      console.log("processingStatus 2 :", processingStatus);

      // Make API call
      const response = await fetch(`${apiHost}${apiPort}/convert`, {
        method: "POST",
        body: formData,
      });
      console.log(" real response ", response);
      const data = await response.json();
      console.log("response data", data);

      const processedSizeMap = {};
      if (data.downloadType === "zip" && Array.isArray(data.files)) {
        // Handle multiple files
        data.files.forEach((file) => {
          const name = file.filename;
          const sizeMB = (file.processedSize / (1024 * 1024)).toFixed(2);
          processedSizeMap[name] = sizeMB;
        });
      } else if (data.downloadType === "single" && data.file) {
        // Handle single file
        const name = data.file.filename;
        const sizeMB = (data.file.processedSize / (1024 * 1024)).toFixed(2);
        processedSizeMap[name] = sizeMB;
      }
      setProcessedSizesMB(processedSizeMap);

      if (!data.success) {
        throw new Error(data.message || "Processing failed");
      }

      // Update status and store processed files
      const updatedStatus = { ...newStatus };
      console.log("data .success is  ", data.success);

      selectedIndexes.forEach((isSelected, index) => {
        if (isSelected) {
          updatedStatus[index] = data.success == true ? "success" : "error";
          console.log("updated status ", updatedStatus);
        }
      });

      setProcessingStatus(updatedStatus);
      console.log("processingStatus 3 :", processingStatus);
      console.log("image or zip file download link  ", data.downloadLink);
      if (data.downloadType === "single") {
        setProcessedFiles([`${data.file.path}`]);
      } else if (data.downloadType === "zip") {
        setProcessedFiles([data.downloadLink]);
      }
      console.log("processed files", processedFiles);
    } catch (error) {
      console.error("Processing error:", error);
      // Set error status for all processing images
      const errorStatus = {};
      selectedIndexes.forEach((isSelected, index) => {
        if (isSelected) {
          errorStatus[index] = "error";
        }
      });
      setProcessingStatus(errorStatus);
      alert("Error processing images: " + error.message);
    }
  };

  const handleDownloadProcessed = async () => {
    console.log("now we handling the download button for zip file ");

    if (!processedFiles.length) {
      console.error("No processed files available to download.");
      return;
    }
    console.log("processed Files", processedFiles);
    for (const result of processedFiles) {
      console.log("result", result);

      try {
        const response = await fetch(`${apiHost}${apiPort}${result}`);
        console.log(response);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        // Use reduceRight to extract the filename
        const filename = result
          .split("/")
          .reduceRight((acc, curr) => curr || acc, "");

        link.href = url;
        console.log("filename", filename);
        link.download = `${filename}`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Download error:", error);
      }
    }
  };

  var selectedImagesCount = (selectedIndexes = []) => {
    // Default value is an empty array
    if (!Array.isArray(selectedIndexes) || selectedIndexes.length === 0) {
      return 0;
    }
    let count = selectedIndexes.filter((value) => value === true).length;
    return count;
  };

  const selectedAll = () => {
    if (!Array.isArray(selectedIndexes) || selectedIndexes.length === 0) {
      alert("Upload images first");
      return;
    }

    const allSelected = selectedIndexes.every((value) => value === true);
    const newSelection = selectedIndexes.map(() => !allSelected);
    setSelectedIndexes(newSelection);
  };

  // const renderUploadView = () => (
  //     <div
  //         className={`border-2 p-8 rounded-xl  transition-colors ${isDragging ? 'border-blue-600 bg-blue-50' : 'border-blue-500 bg-gray-50'}`}
  //         style={{ boxShadow: "5px 5px 5px #4285F4" }}
  //         onDragOver={handleDragOver}
  //         onDragLeave={handleDragLeave}
  //         onDrop={handleDrop}
  //     >
  //         <div className="justify-self-center my-5 mx-auto" style={{ width: "100px", height: "100px" }}>
  //             <img src={filetype} alt="files" className="w-full h-full" />
  //         </div>
  //         <div className="flex justify-center my-3 md:my-10 gap-5 md:gap-10">
  //             <label className="bg-blue-500 content-center  text-white px-3 md:px-32 py-1 md:py-4 rounded-full cursor-pointer hover:bg-blue-600 transition-colors">
  //                 Choose files
  //                 <input
  //                     type="file"
  //                     multiple
  //                     accept=".png,.jpg,.jpeg"
  //                     className="hidden"
  //                     onChange={handleFileChange}
  //                 />
  //             </label>
  //             <Gdrive />
  //             <Drop />
  //         </div>
  //         <div className="text-center text-gray-500">
  //             <span>Drag and drop files here (PNG, JPG, JPEG only, max: 10 images)</span>
  //         </div>
  //     </div>
  // );

  const renderUploadView = () => (
    <>
      <div className="lg:flex  lg:justify-between items-center p-4  rounded">
        <div className="flex gap-4 md:justify-center md:my-5">
          <label className="bg-blue-500 text-white px-4 py-3 rounded-full cursor-pointer hover:bg-blue-600 transition-colors">
            Add More Images
            <input
              type="file"
              multiple
              accept=".png,.jpg,.jpeg"
              className="hidden"
              onChange={handleFileChange}
            />
          </label>
          {/* <Gdrive {...gdriveProps} />
                    <Drop {...dropboxProps} /> */}
        </div>

        <div className="md:flex  mt-3 md:mt-0 md:justify-center lg:gap-5 xl:gap-12 items-center">
          <div>
            <label className="mx-3 md:mx-0 md:pr-3 xl:pr-5" htmlFor="formatid">
              Convert to
            </label>

            <input
              className=""
              name="formatid"
              id="formatid"
              value={convertFormat}
              style={{
                color: "#4285F4",
                border: "1px solid #4285F4",
                borderRadius: "20px",
                padding: "10px 20px",
              }}
              readOnly
              //   onMouseEnter={handleInputInteraction}
              onClick={handleInputInteraction}
            ></input>
            {showDiv && (
              <div
                className="grid grid-cols-2 gap-3  absolute  md:top-[32rem] lg:top-[29rem]  xl:top-[27rem]  right-[7rem] md:right-[23rem]  xl:right-[32rem]  "
                style={{
                  border: " 1px solid #4285F4 ",
                  padding: "20px",
                  borderRadius: "20px",
                  width: "15rem",
                  backgroundColor: "#F5F5F5",
                  zIndex: "999",
                }}
                // onMouseLeave={handleMouseLeave}
                
              >
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("none")}
                >
                  None
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("jpg")}
                >
                  JPG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("png")}
                >
                  PNG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("svg")}
                >
                  SVG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("webp")}
                >
                  WEBP
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("pdf")}
                >
                  PDF
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("tiff")}
                >
                  TIFF
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("avif")}
                >
                  AVIF
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("jpeg")}
                >
                  JPEG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("heic")}
                >
                  HEIC
                </button>
              </div>
            )}

            <div className="" style={{ width: "15px", height: "10px" }}>
              <img
                onClick={handleInputInteraction}
                src={downarrow}
                className="h-full w-full  relative left-[200px]  md:left-[196px] bottom-[24px] "
                alt="down Arrow"
                style={{ firstarrow, cursor: "pointer" }}
              />
            </div>
          </div>
          <div>
            <label className="mx-3 md:mx-0 md:pr-3 xl:pr-5" htmlFor="compid">
              Compress
            </label>

            <input
              name="compid"
              id="compid"
              value={compressSize}
              style={{
                color: "#4285F4",
                border: "1px solid #4285F4",
                borderRadius: "20px",
                padding: "10px 20px",
              }}
              readOnly
              //   onMouseEnter={handleInputInteraction2}
              onClick={handleInputInteraction2}
            ></input>

            {showDiv2 && (
              <div
                className="grid grid-cols-1 gap-3 absolute  md:top-[32rem] lg:top-[29rem]  xl:top-[27rem] right-[5rem] md:right-[10rem] lg:right-[10rem] xl:right-[14rem] "
                style={{
                  border: " 1px solid #4285F4 ",
                  padding: "20px",
                  borderRadius: "20px",
                  width: "8rem",
                  backgroundColor: "#F5F5F5",
                  zIndex: "100",
                }}
              >
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("none")}
                >
                  None
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("25%")}
                >
                  25%
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("50%")}
                >
                  50%
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("75%")}
                >
                  75%
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("100%")}
                >
                  100%
                </button>
              </div>
            )}

            <div className="" style={{ width: "15px", height: "10px" }}>
              <img
                onClick={handleInputInteraction2}
                src={downarrow}
                className="h-full w-full  relative left-[200px]  md:left-[196px] bottom-[24px]  "
                alt="down Arrow"
                style={{ secondarrow }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className={`border-2 p-5 rounded-xl transition-colors ${
          isDragging
            ? "border-blue-600 bg-blue-50"
            : "border-blue-500 bg-gray-50"
        }`}
        style={{ boxShadow: "5px 5px 5px #4285F4" }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <div
          className="justify-self-center  mx-auto"
          style={{ width: "100px", height: "100px" }}
        >
          <img src={filetype} alt="files" className="w-full h-full" />
        </div>

        <div className="flex justify-center my-1 md:my-5 gap-5 md:gap-10">
          <label className="bg-blue-500 content-center text-white px-3 md:px-32 py-1 md:py-4 rounded-full cursor-pointer hover:bg-blue-600 transition-colors">
            Choose files
            <input
              type="file"
              multiple
              accept=".png,.jpg,.jpeg"
              className="hidden"
              onChange={handleFileChange}
            />
          </label>
          {/* <Gdrive {...gdriveProps} />
                <Drop {...dropboxProps} /> */}
        </div>
        <div className="text-center text-gray-500 text-[12px] lg:text-[16px]">
          <span>
            Upload files here ( {io_type || "PNG, JPG, JPEG "} only, max: 10
            images)
          </span>
        </div>
      </div>
    </>
  );
  //  ============

  const renderGalleryView = () => (
    <div className="">
      <div className="lg:flex  lg:justify-between items-center p-4  rounded">
        <div className="flex gap-4 md:justify-center md:my-5">
          <label className="bg-blue-500 text-white px-4 py-3 rounded-full cursor-pointer hover:bg-blue-600 transition-colors">
            Add More Images
            <input
              type="file"
              multiple
              accept=".png,.jpg,.jpeg"
              className="hidden"
              onChange={handleFileChange}
            />
          </label>
          {/* <Gdrive {...gdriveProps} />
                    <Drop {...dropboxProps} /> */}
        </div>

        <div className="md:flex  mt-3 md:mt-0 md:justify-center lg:gap-5 xl:gap-12 items-center">
          <div>
            <label className="mx-3 md:mx-0 md:pr-3 xl:pr-5" htmlFor="formatid">
              Convert to
            </label>

            <input
              className=""
              name="formatid"
              id="formatid"
              value={convertFormat}
              style={{
                color: "#4285F4",
                border: "1px solid #4285F4",
                borderRadius: "20px",
                padding: "10px 20px",
              }}
              readOnly
              //   onMouseEnter={handleInputInteraction}
              onClick={handleInputInteraction}
            ></input>
            {showDiv && (
              <div
                className="grid grid-cols-2 gap-3  absolute  md:top-[32rem] lg:top-[29rem]  xl:top-[27rem]  right-[7rem] md:right-[23rem]  xl:right-[32rem]  "
                style={{
                  border: " 1px solid #4285F4 ",
                  padding: "20px",
                  borderRadius: "20px",
                  width: "15rem",
                  backgroundColor: "#F5F5F5",
                  zIndex: "999",
                }}
                // onMouseLeave={handleMouseLeave}
              >
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("none")}
                >
                  None
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("jpg")}
                >
                  JPG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("png")}
                >
                  PNG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("svg")}
                >
                  SVG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("webp")}
                >
                  WEBP
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("pdf")}
                >
                  PDF
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("tiff")}
                >
                  TIFF
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("avif")}
                >
                  AVIF
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("jpeg")}
                >
                  JPEG
                </button>
                <button
                  className="choicecolor"
                  onClick={() => formatChangeEvent("heic")}
                >
                  HEIC
                </button>
              </div>
            )}

            <div className="" style={{ width: "15px", height: "10px" }}>
              <img
                onClick={handleInputInteraction}
                src={downarrow}
                className="h-full w-full  relative left-[200px]  md:left-[196px] bottom-[24px] "
                alt="down Arrow"
                style={{ firstarrow }}
              />
            </div>
          </div>
          <div>
            <label className="mx-3 md:mx-0 md:pr-3 xl:pr-5" htmlFor="compid">
              Compress
            </label>

            <input
              name="compid"
              id="compid"
              value={compressSize}
              style={{
                color: "#4285F4",
                border: "1px solid #4285F4",
                borderRadius: "20px",
                padding: "10px 20px",
              }}
              readOnly
              //   onMouseEnter={handleInputInteraction2}
              onClick={handleInputInteraction2}
            ></input>

            {showDiv2 && (
              <div
                className="grid grid-cols-1 gap-3 absolute  md:top-[32rem] lg:top-[29rem]  xl:top-[27rem] right-[5rem] md:right-[10rem] lg:right-[10rem] xl:right-[14rem] "
                style={{
                  border: " 1px solid #4285F4 ",
                  padding: "20px",
                  borderRadius: "20px",
                  width: "8rem",
                  backgroundColor: "#F5F5F5",
                  zIndex: "100",
                }}
              >
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("none")}
                >
                  None
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("25%")}
                >
                  25%
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("50%")}
                >
                  50%
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("75%")}
                >
                  75%
                </button>
                <button
                  className="choicecolor"
                  onClick={() => compressSizeChangeEvent("100%")}
                >
                  100%
                </button>
              </div>
            )}

            <div className="" style={{ width: "15px", height: "10px" }}>
              <img
                onClick={handleInputInteraction2}
                src={downarrow}
                className="h-full w-full  relative left-[200px]  md:left-[196px] bottom-[24px]  "
                alt="down Arrow"
                style={{ secondarrow }}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className=" md:h-[500px] overflow-hidden "
        style={{
          backgroundColor: "#F5F5F5",
          border: "3px solid #4285F4",
          borderRadius: "27px",
        }}
      >
        <div className="flex justify-between mt-9 mb-4 px-6">
          <div>
            <input
              type="checkbox"
              checked={selectedIndexes.every((value) => value === true)}
              onChange={selectedAll}
              className="w-4 h-4 accent-blue-500 text-white bg-white border-gray-300 rounded"
            />
            <span
              onClick={selectedAll}
              className="ps-2 cursor-pointer select-none"
            >
              {selectedIndexes.every((value) => value === true)
                ? "Deselect all"
                : "Select all"}
            </span>
          </div>
          <div>
            <span> {selectedImagesCount(selectedIndexes)} File selected</span>
          </div>
        </div>
        <div
          className=" grid   md:grid-cols-4   lg:grid-cols-5 md:gap-4  xl:gap-10 p-5 "
          style={{ backgroundColor: "#F5F5F5" }}
        >
          {selectedFiles.map((file, index) => (
            <>
              <div>
                <div
                  key={index}
                  className="relative   rounded-xl my-2 md:my-0  "
                  style={{ overflow: "hidden", border: "5px solid  #4285F4 " }}
                >
                  <img
                    src={file.preview}
                    alt={`Preview ${index}`}
                    className="w-full  md:h-16 lg:h-32 object-cover "
                  />

                  <div className="absolute top-2 right-2 flex gap-2 z-40">
                    <button
                      onClick={() => handleRemoveImage(index)}
                      className=""
                    >
                      {/* <Trash2 className="w-4 h-4" /> */}
                      <img src={closebtn} alt="close button" />
                    </button>
                  </div>
                  <div className="absolute top-2 left-2 z-40">
                    <input
                      type="checkbox"
                      checked={selectedIndexes[index]}
                      onChange={() => toggleImageSelection(index)}
                      className="w-4 h-4 accent-blue-500 text-white bg-white border-gray-300 rounded "
                    />
                  </div>
                  {processingStatus[index] && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-60 ">
                      {processingStatus[index] === "processing" && (
                        <Loader2 className="w-8 h-8 text-white animate-spin" />
                      )}
                      {processingStatus[index] === "success" && (
                        // < Check className="w-8 h-8 text-green-500" />
                        <div className="w-[40px] h-[40px]">
                          <img
                            className="w-full h-full"
                            src={done}
                            alt="processed"
                          />
                        </div>
                      )}
                      {processingStatus[index] === "error" && (
                        <X className="w-8 h-8 text-red-500" />

                        // <img src={closebtn} alt="close button" />
                      )}
                    </div>
                  )}
                </div>
                <div className="text-left pl-5 mt-1">
                  <span>
                    {processedSizesMB[file.file.name]
                      ? `${processedSizesMB[file.file.name]} MB`
                      : `${(file.file.size / (1024 * 1024)).toFixed(2)} MB`}
                  </span>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      {selectedFiles.length > 0 && (
        <div className="md:flex justify-center gap-4 my-3">
          <button
            onClick={handleProcessImages}
            className="bg-yellow-500 text-white px-6 py-3 rounded-full hover:bg-yellow-600 transition-colors flex items-center justify-center gap-2"
            disabled={Object.values(processingStatus).includes("processing")}
          >
            {Object.values(processingStatus).includes("processing") && (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
            )}
            {Object.values(processingStatus).includes("processing")
              ? "Processing..."
              : "Process Images"}
          </button>

          {processedFiles.length > 0 && (
            <button
              onClick={handleDownloadProcessed}
              className="bg-green-500 text-white px-6 py-3 my-3 md:my-0 rounded-full hover:bg-green-600 transition-colors"
            >
              Download Images
            </button>
          )}
        </div>
      )}
    </div>
  );

  // useEffect(() => {
  //     // Cleanup URLs when the component unmounts or when selectedFiles changes
  //     return () => {
  //         selectedFiles.forEach(file => {
  //             if (file.preview) {
  //                 // Revoke the object URL after state updates
  //                 URL.revokeObjectURL(file.preview);
  //             }
  //         });
  //     };
  // }, [selectedFiles]);

  return (
    <div className="p-4">
      {showUploadView ? renderUploadView() : renderGalleryView()}

      {visible && (
        <Alert
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: "999",
          }}
          message="WARNING"
          description={warMsg}
          type="error"
          onClose={() => setVisible(false)}
          closable
          showIcon
        />
      )}

      {infoMsg && (
        <Alert
          style={{
            position: "fixed",
            top: "20px",
            left: "33vw",
            zIndex: "999",
          }}
          message="Informational Notes"
          description={infoCnt}
          type="info"
          showIcon
        />
      )}
    </div>
  );
};

export default UploadD;
